import React from "react";
import notify from "devextreme/ui/notify";
import Form, { SimpleItem, GroupItem, Label } from "devextreme-react/form";
import "devextreme-react/text-area";
import { Button, ScrollView } from "devextreme-react";
import UserInfo from "../../UserInfo";
import {
  inserirOuAtualizar,
  criarReceitasDs,
  criarDiatDs,
} from "../../DataSources";
import { Popup, ToolbarItem } from "devextreme-react/popup";
import ReceitasBox from "./ReceitasBox";
import ShowError from "../../AppServices";

let _cadastroCorrente = undefined;
let _cancelando = false;

const template = {
  id: undefined,
  sequencial: undefined,
  prefeituraId: undefined,
  descricao: "",
  tributaria: true,
  origem: "",
  formaPagto: 0,
  tipoReceita: 0,
  contabilId: undefined,
  multaId: undefined,
  jurosId: undefined,
  correcaoId: undefined,
  baseId: undefined,
  diatId: undefined,
  baseJuros: 0,
  baseMulta: 0,
  jurosEspecial: 0,
  inicioJuros: 0,
  tipoJuros: 0,
  jurosMaximo: 0,
  valorJurosMaximo: 0,
  tipoEspecialReceita: ""
};

export default class ReceitasForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = { ...(_cadastroCorrente || template) };
    template.prefeituraId = UserInfo.getPrefeitura();
    this.receitasDs = criarReceitasDs();

    this.ok = this.ok.bind(this);
    this.cancel = this.cancel.bind(this);
    this.saidaProgramada = false;
    this.receitasBoxRef = React.createRef();
    this.onReceitaSelecionadaPesquisa =
      this.onReceitaSelecionadaPesquisa.bind(this);

    this.baseJurosOptions = {
      editorType: "dxSelectBox",
      searchEnabled: false,
      dataSource: [
        { id: 0, descricao: "PADRÃO" },
        { id: 1, descricao: "PRINCIPAL" },
        { id: 2, descricao: "PRINCIPAL E MULTA" },
        { id: 3, descricao: "VALOR CORRIGIDO" },
        { id: 4, descricao: "VALOR CORRIGIDO E MULTA" },
      ],
      valueExpr: "id",
      displayExpr: "descricao",
    };

    this.baseMultaOptions = {
      editorType: "dxSelectBox",
      searchEnabled: false,
      dataSource: [
        { id: 0, descricao: "PADRÃO" },
        { id: 1, descricao: "NÃO COBRAR" },
        { id: 2, descricao: "SOBRE PRINCIPAL" },
        { id: 3, descricao: "SOBRE VALOR CORRIGIDO" },
      ],
      valueExpr: "id",
      displayExpr: "descricao",
    };

    this.jurosMaximoOptions = {
      editorType: "dxSelectBox",
      searchEnabled: false,
      dataSource: [
        { id: 0, descricao: "PADRÃO" },
        { id: 1, descricao: "SIM" },
        { id: 2, descricao: "NÃO" },
      ],
      valueExpr: "id",
      displayExpr: "descricao",
    };

    this.inicioJurosOptions = {
      editorType: "dxSelectBox",
      searchEnabled: false,
      dataSource: [
        { id: 0, descricao: "PADRÃO" },
        { id: 1, descricao: "VENCIMENTO" },
        { id: 2, descricao: "DIA SEGUINTE" },
        { id: 3, descricao: "MES SUBSEQUENTE" },
      ],
      valueExpr: "id",
      displayExpr: "descricao",
    };

    this.tipoJurosOptions = {
      editorType: "dxSelectBox",
      searchEnabled: false,
      dataSource: [
        { id: 0, descricao: "PADRÃO" },
        { id: 1, descricao: "PRÓ-RATA" },
        { id: 2, descricao: "DESPREZAR FRAÇÕES MÊS" },
        { id: 3, descricao: "NÃO FRACIONÁVEL" },
        { id: 4, descricao: "SGT ANTIGO" },
      ],
      valueExpr: "id",
      displayExpr: "descricao",
    };

    this.jurosEspecialOptions = {
      editorType: "dxSelectBox",
      searchEnabled: false,
      dataSource: [
        { id: 0, descricao: "PADRÃO" },
        { id: 1, descricao: "SELIC MAIS UM POR CENTO" },
      ],
      valueExpr: "id",
      displayExpr: "descricao",
    };

    this.simNaoOptions = {
      editorType: "dxSelectBox",
      searchEnabled: false,
      dataSource: [
        { id: true, descricao: "SIM" },
        { id: false, descricao: "NAO" },
      ],
      valueExpr: "id",
      displayExpr: "descricao",
    };

    this.naturezaOptions = {
      editorType: "dxSelectBox",
      searchEnabled: false,
      dataSource: [
        { id: true, descricao: "TRIBUTARIA" },
        { id: false, descricao: "NAO TRIBUTARIA" },
      ],
      valueExpr: "id",
      displayExpr: "descricao",
    }

    this.tipoEspecialOptions = {
      editorType: "dxSelectBox",
      dataSource: [
        { id: "", valor: " " },
        { id: "IPTU", valor: "IPTU" },
      ],
      valueExpr: "id",
      displayExpr: "valor",
    }
  }

  onReceitaSelecionadaPesquisa(e) {
    switch (this.state.identificador) {
      case 0:
        this.setState({
          multaId: e.row.data.sequencial,
          popupVisivel: false,
        });
        break;
      case 1:
        this.setState({
          jurosId: e.row.data.sequencial,
          popupVisivel: false,
        });
        break;
      case 2:
        this.setState({
          correcaoId: e.row.data.sequencial,
          popupVisivel: false,
        });
        break;
      case 3:
        this.setState({
          baseId: e.row.data.sequencial,
          popupVisivel: false,
        });
        break;
      case 4:
        this.setState({
          diatId: e.row.data.sequencial,
          popupVisivel: false,
        });
        break;
    }
  }

  componentDidMount() {
    if (_cadastroCorrente === undefined) {
      if (this.props.match.params.id !== undefined) {
        this.receitasDs
          .byKey(this.props.match.params.id)
          .then((data) => {
            if (data === undefined) {
              notify("Registro não encontrado.", "error");
              this.props.history.push("/receitas");
            }
            this.setState(data);
            console.log("receita aberta", data);
          })
          .catch((error) => {
            ShowError(error.response.data);
            notify(error, "error", 2000);
            this.props.history.goBack();
          });
      }
    } else {
      this.setState({ ...template });
    }
    _cancelando = false;
  }

  componentWillUnmount() {
    if (this.props.match.params.id !== undefined) {
      _cadastroCorrente = _cancelando ? undefined : this.state;
    }
  }

  render() {
    const escolherTipoReceita = {
      editorType: "dxSelectBox",
      searchEnabled: false,
      dataSource: [
        { id: 0, descricao: "Receita" },
        { id: 1, descricao: "Sub-Receita" },
        { id: 2, descricao: "Receita de encargos" },
      ],
      valueExpr: "id",
      displayExpr: "descricao",
    };

    const escolherFormaPagto = {
      editorType: "dxSelectBox",
      searchEnabled: false,
      dataSource: [
        { id: 0, descricao: "DAM" },
        { id: 1, descricao: "Boleto Bancário" },
      ],
      valueExpr: "id",
      displayExpr: "descricao",
    };

    const diatOptions = {
      editorType: "dxSelectBox",
      searchEnabled: true,
      dataSource: criarDiatDs(),
      valueExpr: "id",
      displayExpr: "codigoDeOrigem",
    };

    return (
      <React.Fragment>
        <div className={"content-block dx-card responsive-paddings"}>
          <Form formData={this.state} colCount={2}>
            <GroupItem
              caption="INFORMAÇÕES DA RECEITA"
              colSpan={2}
              colCount={3}
            >
              <SimpleItem dataField={"descricao"} colSpan={2}>
                <Label text="Descrição" />
              </SimpleItem>

              <SimpleItem dataField={"tributaria"} editorType={"dxSelectBox"} editorOptions={this.naturezaOptions}>
                <Label text="Natureza" />
              </SimpleItem>

              <SimpleItem dataField={"origem"}>
                <Label text="Origem" />
              </SimpleItem>

              <SimpleItem dataField={"origemCda"}>
                <Label text="Origem CDA" />
              </SimpleItem>

              <SimpleItem dataField={"classificacao"}>
                <Label text="Classificação" />
              </SimpleItem>

              <SimpleItem
                dataField={"formaPagto"}
                editorType={"dxLookup"}
                editorOptions={escolherFormaPagto}
              >
                <Label text="Forma de Pagamento" />
              </SimpleItem>

              <SimpleItem
                dataField={"tipoReceita"}
                editorType={"dxLookup"}
                editorOptions={escolherTipoReceita}
              >
                <Label text="Tipo da Receita" />
              </SimpleItem>

              <SimpleItem dataField={"codContabilPrincipal"}>
                <Label text="CC Principal" />
              </SimpleItem>

              <SimpleItem dataField={"codContabilMulta"}>
                <Label text="CC Multa" />
              </SimpleItem>

              <SimpleItem dataField={"codContabilJuros"}>
                <Label text="CC Juros" />
              </SimpleItem>

              <SimpleItem dataField={"codContabilCorrecao"}>
                <Label text="CC Correção" />
              </SimpleItem>

              <SimpleItem
                dataField={"baseJuros"}
                editorType={"dxSelectBox"}
                editorOptions={this.baseJurosOptions}
              >
                <Label text="Base Juros" />
              </SimpleItem>

              <SimpleItem
                dataField={"baseMulta"}
                editorType={"dxSelectBox"}
                editorOptions={this.baseMultaOptions}
              >
                <Label text="Base Multa" />
              </SimpleItem>

              <SimpleItem
                dataField={"jurosEspecial"}
                editorType={"dxSelectBox"}
                editorOptions={this.jurosEspecialOptions}
              >
                <Label text="Juros Especial" />
              </SimpleItem>

              <SimpleItem
                dataField={"inicioJuros"}
                editorType={"dxSelectBox"}
                editorOptions={this.inicioJurosOptions}
              >
                <Label text="Início Juros" />
              </SimpleItem>

              <SimpleItem
                dataField={"tipoJuros"}
                editorType={"dxSelectBox"}
                editorOptions={this.tipoJurosOptions}
              >
                <Label text="Início Juros" />
              </SimpleItem>

              <SimpleItem
                dataField={"jurosMaximo"}
                editorType={"dxSelectBox"}
                editorOptions={this.jurosMaximoOptions}
              >
                <Label text="Juros Máximo" />
              </SimpleItem>

              <SimpleItem
                dataField={"valorJurosMaximo"}
                editorType={"dxNumberBox"}
                format={"#,##0.000000"}
                editorOptions={{ format: "#,##0.000000" }}
              >
                <Label text="Vr. Juros Máximo (%)" />
              </SimpleItem>
              <SimpleItem dataField={"grupo"}>
                <Label text="Grupo" />
              </SimpleItem>
              <SimpleItem dataField={"stGeraDivida"} editorType={"dxSelectBox"} editorOptions={this.simNaoOptions}>
                <Label text="Gera Divida" />
              </SimpleItem>
              <SimpleItem dataField={"stDividaAtiva"} editorType={"dxSelectBox"} editorOptions={this.simNaoOptions}>
                <Label text="Receita de DIAT" />
              </SimpleItem>

              <SimpleItem dataField={"codigoLivro"}>
                <Label text="Código Livro" />
              </SimpleItem>

              <SimpleItem dataField={"segmentoFebraban"} editorOptions={{ maxLength: 1 }}>
                <Label text="Segmento Febraban" />
              </SimpleItem>

              <SimpleItem dataField={"codigoFebraban"} editorOptions={{ maxLength: 4 }}>
                <Label text="Código Febraban" />
              </SimpleItem>

              <SimpleItem colSpan={2}  dataField={"tipoReceitaEspecial"} editorType={"dxSelectBox"} editorOptions={this.tipoEspecialOptions} helpText={"Muito importante para IPTU e impostos listados no campo, atenção!"}>
                <Label text="Tipo Especial Sistema" />
              </SimpleItem>

            </GroupItem>
          </Form>
          <div
            style={{
              display: "flex",
              marginTop: "25px",
              justifyContent: "center",
              alignContent: "center",
              justifyItems: "center",
              alignItems: "center",
            }}
          >
            <div style={{ display: "inline-block" }}>
              <Button
                width={120}
                text="Salvar"
                type="success"
                onClick={this.ok}
              />
            </div>
            <div style={{ marginLeft: "10px" }}>
              <Button text="Cancelar" onClick={this.cancel} width={120} />
            </div>
          </div>
        </div>
        <Popup
          visible={this.state.popupVisivel}
          onHiding={() => {
            this.setState({ popupVisivel: false });
          }}
          dragEnabled={false}
          closeOnOutsideClick={true}
          showCloseButton={true}
          showTitle={true}
          width={"90%"}
          height={"90%"}
          title="Pesquisar Receita"
        >
          <ScrollView showScrollbar={"always"}>
            <ReceitasBox
              onSelecionado={this.onReceitaSelecionadaPesquisa}
              ref={this.receitasBoxRef}
            />
          </ScrollView>
          <ToolbarItem
            toolbar={"bottom"}
            widget="dxButton"
            location="center"
            options={{
              text: "Fechar",
              type: "default",
              width: 150,
              onClick: () => this.setState({ popupVisivel: false }),
            }}
          ></ToolbarItem>
        </Popup>
      </React.Fragment>
    );
  }

  ok() {
    const entidade = { ...this.state, prefeituraId: UserInfo.getPrefeitura() };
    inserirOuAtualizar(this.receitasDs, entidade)
      .then(
        function () {
          _cadastroCorrente = undefined;
          _cancelando = true;
          notify("Receita cadastrado com sucesso.", "success");
          this.props.history.goBack();
        }.bind(this)
      )
      .catch((error) => {
        ShowError(error.response.data);
        notify(error, "error", 2000);
      });
  }

  cancel() {
    _cadastroCorrente = undefined;
    _cancelando = true;
    notify("Operação cancelada", "warning");
    this.props.history.goBack();
  }
}
